import { useState, useEffect } from "react";
import "./Reschedule_Alert_Popup.css";
 
interface AlertPopupProps {
    isOpen: boolean;
    onClose: () => void;
    message: string;
    title?: string; // Add optional title prop
}
 
function Component_Popup_Alert({
    isOpen,
    onClose,
    message,
    title = "Alert" // Default value is "Alert"
}: AlertPopupProps) {
    const handleClose = () => {
        onClose();
    };
 
    if (!isOpen) return null;
 
    return (
        <div className="alert-overlay">
            <div className="alert-container">
                <div className="alert-header">
                    <div className="alert-spacer"></div>
                    <h3 className="alert-title">{title}</h3>
                    <button className="alert-close-btn" onClick={handleClose}>
                        {/* &times; */}
                    </button>
                </div>
 
                <div className="alert-content">
                    <p className="alert-message">{message}</p>
                </div>
 
                <div className="alert-footer">
                    <button className="alert-ok-btn" onClick={handleClose}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
}
 
export default Component_Popup_Alert;